
const digest = '2021603a46aa1ad90bf23968ae296b4a76ce22e89590e7451d30ddcac665ef29';
const classes = {"wrapper":"_wrapper_c24e4_1","pleft":"_pleft_c24e4_10","pright":"_pright_c24e4_13","content":"_content_c24e4_16","pulseAnimate":"_pulseAnimate_c24e4_1","ring1":"_ring1_c24e4_40","ring2":"_ring2_c24e4_43","ring3":"_ring3_c24e4_46","modalContent":"_modalContent_c24e4_56","message":"_message_c24e4_59"};
const css = `._wrapper_c24e4_1 {
  height: 40px;
  width: 40px;
  position: absolute;
  cursor: pointer;
  background: #e9effb;
  border-radius: 100%;
  top: -10px;
}
._wrapper_c24e4_1._pleft_c24e4_10 {
  left: -10px;
}
._wrapper_c24e4_1._pright_c24e4_13 {
  right: -10px;
}
._wrapper_c24e4_1 ._content_c24e4_16 {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_c24e4_1 img {
  position: absolute;
  height: 20px;
  z-index: 10;
  cursor: pointer;
}
._wrapper_c24e4_1 span {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #e9effb;
  border: 1px solid #1665d9;
  border-radius: 100%;
  opacity: 0.8;
  animation: _pulseAnimate_c24e4_1 4s ease-out infinite;
}
._wrapper_c24e4_1 ._ring1_c24e4_40 {
  animation-delay: 0s;
}
._wrapper_c24e4_1 ._ring2_c24e4_43 {
  animation-delay: 1s;
}
._wrapper_c24e4_1 ._ring3_c24e4_46 {
  animation-delay: 2s;
}
@keyframes _pulseAnimate_c24e4_1 {
  100% {
    opacity: 0;
    transform: scale(1.3);
  }
}

._modalContent_c24e4_56 {
  font-family: Rubik, "sans-serif";
}
._modalContent_c24e4_56 ._message_c24e4_59 {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  